import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import LanguageIcon from '@mui/icons-material/Language';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

const languages = ['en', 'kn', 'hi', 'ta', 'te'];

const LanguageSelector = ({ user }) => {
  const { t, i18n } = useTranslation();

  const handleLanguageChange = (event) => {
    const newLang = event.target.value;
    i18n.changeLanguage(newLang); // Update language
    localStorage.setItem('language', JSON.stringify(newLang));
  };

  return (
    <Box display='flex' flexDirection='row' alignItems='center'>
      <FormControl
        variant="standard"
        size="small"
        sx={{ minWidth: 120, mx: 2 }}
      >
        <Select
          value={i18n.language}
          onChange={handleLanguageChange}
          disableUnderline
          inputProps={{ 'aria-label': t('language_selector.header') }}
          startAdornment={
            <LanguageIcon
              fontSize="small"
              sx={{ mr: 1, color: 'text.secondary' }}
            />
          }
          sx={{
            fontSize: '0.875rem',
            color: 'text.secondary',
            '& .MuiSelect-select': { display: 'flex', alignItems: 'center', py: 0.5 },
          }}
        >
          {languages.map((language) => (
            <MenuItem
              key={language}
              value={language}
            >
              {t(`language_selector.options.${language}`)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default LanguageSelector;
